import { Moment } from 'moment';
import SlaNoteType from './SlaNoteType';
import SlaV2MediaFile from './SlaV2MediaFile';
import SlaNoteTargetType from '../constants/SlaNoteTargetType';
import SlaNoteTarget from './SlaNoteTarget';

export default class SlaV2Note {
  id!: number;
  subject = '';
  subjectIdentifier: string | null = null;
  type!: SlaNoteType;
  modifiedOn!: Moment;
  modifiedById: number | null = null;
  modifiedByName: string | null = null;
  visibilityLevel!: number;
  validFrom: Moment | null = null;
  validTill: Moment | null = null;
  content = '';
  mediaFile: SlaV2MediaFile | null = null;

  matchesTarget(target: SlaNoteTarget): boolean {
    switch (target.type) {
      case SlaNoteTargetType.CONTACT:
        return target.title === this.subjectIdentifier;
      case SlaNoteTargetType.VEHICLE:
        return target.description === this.subjectIdentifier;
    }
  }
}